import { lazy } from "react";
export var LazyRetailerReportBrandModal = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-retailer-report-brand-modal" */ "@faire/retailer-visitor-shared/views/brand/ReportBrandIssues/RetailerReportBrandModal/RetailerReportBrandModal").then(function(m) {
        return {
            default: m.RetailerReportBrandModal
        };
    });
});
